'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Dropdown = require('../../blocks/Dropdown');

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// import ContainerSelectable from '../../blocks/ContainerSelectable';


function List(_ref, context) {
  var children = _ref.children,
      name = _ref.name,
      rest = _objectWithoutProperties(_ref, ['children', 'name']);

  var _context$DROPDOWN_CON = context[_constants.DROPDOWN_CONTEXT],
      activeItem = _context$DROPDOWN_CON.activeItem,
      handleItemClick = _context$DROPDOWN_CON.handleItemClick,
      selectable = _context$DROPDOWN_CON.selectable;


  function handleClick(e, itemId) {
    if (selectable) {
      handleItemClick(e, itemId);
    }
  }

  var listItems = _react.Children.map(children, function (child, i) {
    // this ternary allows us to not have to add a name prop
    // for a dropdown that only contains a single list
    var identifier = child.props.id || i.toString();
    var itemId = name.length ? name + ':' + identifier : identifier;
    var isActive = activeItem === itemId;
    var defaultModifiers = ['fluid'];
    var modifierProps = child.props.modifiers.concat(isActive ? 'active' : []);
    var listItem = _react2.default.cloneElement(child, {
      onClick: function onClick(e) {
        return handleClick(e, itemId);
      },
      modifiers: defaultModifiers.concat(modifierProps)
    });

    return listItem;
  });

  return _react2.default.createElement(
    _Dropdown2.default.List,
    _extends({ name: name }, rest),
    listItems
  );
}

List.contextTypes = _defineProperty({}, _constants.DROPDOWN_CONTEXT, _propTypes2.default.object.isRequired);

List.defaultProps = {
  name: ''
};

List.propTypes = {
  name: _propTypes2.default.string,
  children: _propTypes2.default.node.isRequired
};

exports.default = List;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/Dropdown/List.js
// module id = 1654
// module chunks = 2